// PopupContext.js
import React, { createContext, useState } from 'react';

export const PopupContext = createContext();

export const LoginPopupProvider = ({ children }) => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [direactsecId, setSecId] = useState('');
  const [betSlipOpen, setBetSlipOpen] = useState(false);
  const [isBetUpdate, setIsBetUpdate] = useState(false);
  const [openDialog, setOpenDialog] = useState('');
  const [isBetLoader, setBetLoader] = useState(false);
  const [loaderCounter, setLoaderCounter] = useState(0);
  const [exchangeData, setExchangeDatas] = useState();
  const [stackArray, setStackArray] = useState();
  const [mSideMenu, setmSideMenu] = useState(false);
  const [headerHeight, setheaderHeight] = useState(0);
  const [sessionUpdatevalue, setSessionUpdate] = useState('');
  const [mainHeight, setMainHeight] = useState(0);
  const [betOnProcess, setbetPro] = useState(false);
  const [grulesData, setGrulesData] = useState(null);
  const [eidmid, setEidMid] = useState([])

  const setGameRule = (it) => setGrulesData(it); 

  const setBetOnProcess = (it) => setbetPro(it); 
  const openPopup = () => setPopupOpen(true);
  const closePopup = () => setPopupOpen(false);
  const isLoggedIn = () => setLoggedIn(true);
  const isLoggedOut = () => setLoggedIn(false);
  const clearSecId = () => setSecId('');
  const setSecIds = (id) => setSecId(id);
  const openBetSlip = () => setBetSlipOpen(true);
  const closeBetSlip = () => setBetSlipOpen(false);
  const betUpdated = () => setIsBetUpdate(true);
  const betNotUpdated = () => setIsBetUpdate(false);
  const openDialogSet = (id) => setOpenDialog(id);
  const clearDialog = () => setOpenDialog('');
  const setBetLoder = () => setBetLoader(true);
  const unsetBetLoader = () => setBetLoader(false);
  const openMSideMenu = () => setmSideMenu(true);
  const closeMSideMenu = () => setmSideMenu(false);
  const headerHeightSet = (height) => setheaderHeight(height);
  const mainHeightSet = (height) => setMainHeight(height);
  const sessionUpdate = (height) => setSessionUpdate(height);
  const [oneClickBetUpdate, setclickUpdate] = useState(false);

  const setStackList = (list) => {
    if (list !== undefined) {
      setStackArray(list);      
    }    
  };
  const loaderCounting = (time) => setLoaderCounter(time);
  const setExchangeData = (time) => setExchangeDatas(time);
  const UpdateOneClick = (it) => setclickUpdate(it); 

  return (
    <PopupContext.Provider value={{
      isPopupOpen,
      openPopup,
      closePopup,
      loggedIn,
      isLoggedIn,
      isLoggedOut,
      setSecIds,
      direactsecId,
      clearSecId,
      openBetSlip,
      closeBetSlip,
      betSlipOpen,
      betUpdated,
      betNotUpdated,
      isBetUpdate,
      clearDialog,
      openDialogSet,
      openDialog,
      setBetLoder,
      unsetBetLoader,
      isBetLoader,
      loaderCounting,
      loaderCounter,
      setExchangeData,
      exchangeData,
      setStackList,
      stackArray,
      openMSideMenu,
      closeMSideMenu,
      mSideMenu,
      mainHeight,
      headerHeight,
      headerHeightSet,
      mainHeightSet,
      sessionUpdate,
      sessionUpdatevalue,
      betOnProcess,
      setBetOnProcess,
      UpdateOneClick,
      oneClickBetUpdate,
      setGameRule,
      grulesData
      }}>
      {children}
    </PopupContext.Provider>
  );
};
